import React from 'react'
import { FaRegPaperPlane, FaFacebookSquare, FaInstagram, FaTwitter } from 'react-icons/fa';
import './header.css';
// import coderdane from '../../assets/coderdane.png';
import res from '../../assets/res.gif';

const Header = () => {
  return (
    <div className='dane__header section_padding' id='home'>
      <div className='dane__header-content'>
        <h1 className='header__text'>Launch Iconic Products</h1>
        <p className='header__paragraph'>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Risus ultricies tristique nulla aliquet enim tortor at auctor. Ac odio tempor orci dapibus ultrices in iaculis.
        </p>
        <button type='button'><span><FaRegPaperPlane className='paperplane' /> </span> Let's Work Together</button>

        <div className='social-icon'>
          <FaFacebookSquare className='icon' />
          <FaInstagram className='icon' />
          <FaTwitter className='icon' />
        </div>

      </div>
        <div className='dane__header-image'>
        <img src={res} alt='coderdane' />
        </div>
    </div>
  )
}

export default Header